import { render, staticRenderFns } from "./noData.vue?vue&type=template&id=63ad5d2e&scoped=true&"
import script from "./noData.vue?vue&type=script&lang=ts&"
export * from "./noData.vue?vue&type=script&lang=ts&"
import style0 from "./noData.vue?vue&type=style&index=0&id=63ad5d2e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad5d2e",
  null
  
)

export default component.exports